import React from "react";
import useState from "react-usestateref";
import { SearchCircleIcon, SearchIcon } from "@heroicons/react/outline";
import { Navigate, useNavigate } from "react-router-dom";
import backendService from "../services.js/backendService";
import { Question16Filled } from "@fluentui/react-icons";
import ReactTooltip from "react-tooltip";
import axios from "axios";
import { ThreeDots } from "react-loading-icons";

function SearchQuestionHeader(props) {
  const navigate = useNavigate();
  const [search, setSearch, searchRef] = useState("");
  const [questions, setQuestions] = useState([]);
  const [searching, setSearching] = useState(false);
  
  const searchQuestions = async (query) => {
    if (query.length > 0) {
      setSearching(true);
      await axios
        .get(`${process.env.REACT_APP_URL}/searchquestion/${query}`, {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        })
        .then((res) => {
          setSearching(false);
          setQuestions(res.data.questions);
        })
        .catch((err) => {
          setSearching(false);
          console.log(err);
        });
    }
  };
 

  return (
    <div className="flex flex-wrap sm:flex-nowrap items-center py-3 sm:h-[70px] shadow sticky top-0 bg-palette_color2 z-30">
      <div className="flex justify-center order-1 w-full sm:w-auto sm:justify-start">
        <img
          className="h-[50px] sm:h-[60px] pl-4 sm:pl-8 md:pl-16"
          src={require("../assets/logoon.png")}
          alt="Background"
          onClick={() => navigate("/")}
        />
      </div>
      <div className="relative flex items-center order-3 w-full py-2 sm:w-1/2 md:w-2/5 lg:w-1/3 sm:order-2 sm:py-0 sm:mx-auto">
        <div>
          {searching ? (
            <ThreeDots
              className="w-6 h-6 text-palette_color1 "
              fill="#0077b6"
            />
          ) : (
            <SearchIcon
              className="w-6 h-6  text-palette_color1"
              aria-hidden="true"
            />
          )}
        </div>
        <input
          type="text"
          name="search"
          id="search"
          autoComplete="off"
          className=" border-[1px] border-palette_color1 block text-sm w-full ml-6  py-2 px-3 bg-white appearance-none rounded-sm text-primary placeholder-secondary focus:outline-none focus:z-10 sm:text-sm"
          placeholder="Search..."
          onChange={async (e) => {
            setSearch(e.target.value);
            if (props.getSearch) {
              props?.getSearch(e.target.value);
            }
            await searchQuestions(e.target.value);
          }}
        />
        <div className="w-[91%] h-auto max-h-[40vh] z-50 shadow overflow-x-hidden overflow-y-auto absolute bg-white top-[38px] right-0 chat__container border-x-[1px]   border-palette_color1 ">
          <ul className="cursor-pointer">
            {!searching && searchRef.current.length > 0
              ? questions.map((question) => (
                  <li
                    className="border-b-[1px] border-palette_color1 h-[45px] pl-2  "
                    onClick={() => navigate(`/question/${question._id}`)}
                  >
                    <h3 className="truncate ">{question.title}</h3>
                    <p className="pr-2 text-xs text-right text-palette_color1 ">
                      {question?.tags.map((tag) => "#" + tag + " ")}
                    </p>
                  </li>
                ))
              : null}
          </ul>
        </div>
      </div>
      <div className="flex justify-center order-2 w-full px-4 sm:w-auto sm:justify-end sm:order-3 sm:px-0 sm:pr-8 md:pr-16">
        {!backendService.isLoggedIn() ? (
          <div className="flex flex-col items-center w-full py-2 space-y-2 sm:flex-row sm:w-auto sm:space-y-0 sm:space-x-2 md:space-x-3 sm:py-0">
            <button
              className="w-full sm:w-auto font-robo antialiased font-semibold border-[1px] bg-slate-50 hover:bg-slate-100 rounded-md py-2 px-5 text-medium"
              onClick={() => navigate("/sign-up")}
            >
              Sign up
            </button>
            <button
              className="w-full px-6 py-3 ml-0 antialiased font-semibold leading-4 text-white border-none rounded-md shadow-sm sm:w-auto sm:ml-2 md:ml-3 text-medium font-robo bg-palette_color1 hover:opacity-90 focus:outline-none hover:subpixel-antialiased"
              onClick={() => navigate("/login")}
            >
              {" "}
              Log in
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-between w-full space-y-2 sm:flex-row sm:space-y-0">
            <div className="flex flex-col items-center space-y-2 sm:flex-row sm:space-y-0 sm:space-x-2 md:space-x-3">
              <ReactTooltip delayShow={500} delayHide={100} />

              <h3
                className="pl-0 text-base antialiased font-medium cursor-pointer sm:pl-8 font-robo"
                onClick={() => navigate("/forum")}
              >
                Forum
              </h3>
              <h3
                className="pl-0 text-base antialiased font-medium cursor-pointer sm:pl-8 font-robo"
                onClick={() => navigate("/myquestions")}
              >
                My Questions
              </h3>
            </div>
            <div className="flex items-center space-x-2 md:space-x-3">
              <button
                className="w-full sm:w-auto font-robo antialiased font-semibold border-[1px] bg-slate-50 hover:bg-slate-100 rounded-md py-2 px-5 text-medium"
                onClick={() => {
                  localStorage.clear();
                  window.location.reload(false);
                }}
              >
                Logout
              </button>

              <img
                className="h-[40px] w-[40px] sm:ml-3 rounded-full"
                src={backendService.getLoggedInUser()["profilePicture"] ? backendService.getLoggedInUser()["profilePicture"] : require("../assets/boredApe.png")}
                alt="Background"
                onClick={() => navigate("/login")} // Should this navigate to profile instead?
                  data-tip={backendService.getLoggedInUser()["name"]}
                  data-place="right"
                />
              </div>
            </div>
        )}
      </div>
    </div>
  );
}
export default SearchQuestionHeader;
